import ImageNotSupportedOutlined from '@mui/icons-material/ImageNotSupportedOutlined';
import Box from '@mui/material/Box';
import { t } from 'i18next';
import { useContext, useEffect } from 'react';

import { ROUTE_MAP_HEIGHT_IN_PX } from '~components/Job/RouteMap';
import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Skeleton } from '~components/Skeleton/Skeleton';

import AllFilesTable from '../../AllFilesTable/AllFilesTable';
import AllFilesQueryContext from './AllFilesQueryContext';

export default function AllFilesTab() {
  const allFilesQuery = useContext(AllFilesQueryContext);

  useEffect(() => {
    return () => {
      allFilesQuery.clearQueryData();
    };
  }, []);

  return (
    <Box>
      {allFilesQuery.isFetching ? (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, py: 1 }}>
          {[0, 1, 2, 3].map((row) => (
            <Skeleton key={row} variant="text" height={20} />
          ))}
        </Box>
      ) : (
        <Box sx={{ minHeight: ROUTE_MAP_HEIGHT_IN_PX + 50 }}>
          {allFilesQuery.data &&
            (allFilesQuery.data.length > 0 ? (
              <AllFilesTable files={allFilesQuery.data} />
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  gap: 1,
                }}
              >
                <ImageNotSupportedOutlined />

                <OverflowAwareText
                  sx={{ fontSize: '14px', fontWeight: 600, textAlign: 'center' }}
                >
                  {t('approvals.files.all_files_tab.no_files_message')}
                </OverflowAwareText>
              </Box>
            ))}
        </Box>
      )}
    </Box>
  );
}
